/**
 * The two Application Designer layout modes.
 *
 * FLOW is for content-sized native components, where an element's height is
 * decided by the patient's data and the designer only chooses a column and an
 * ordinal. GRID is for bounded, form-like pages, where an element occupies a
 * designer-chosen rectangle of whole cells.
 *
 * They are separate because forcing a content-sized clinical card onto a
 * fixed-row grid either clips it or leaves dead space, differently for every
 * patient. They are the ONLY two modes: a page declares one, and the shared
 * editor shell, properties panel, cosmetics, registry and persistence are the
 * same either way.
 */
export const LAYOUT_MODE_FLOW = "flow";
export const LAYOUT_MODE_GRID = "grid";

export const LAYOUT_MODES = Object.freeze([LAYOUT_MODE_FLOW, LAYOUT_MODE_GRID]);

export function isLayoutMode(value) {
  return LAYOUT_MODES.includes(value);
}

export function normalizeLayoutMode(value, fallback = LAYOUT_MODE_FLOW) {
  return isLayoutMode(value) ? value : fallback;
}
